import { Variants } from "framer-motion";

/**
 * Fade in animation
 */
export const fadeIn: Variants = {
  hidden: { opacity: 0 },
  visible: { 
    opacity: 1,
    transition: { duration: 0.6 }
  }
};

/**
 * Fade in up animation
 */
export const fadeInUp: Variants = {
  hidden: { opacity: 0, y: 20 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { duration: 0.6 }
  }
};

/**
 * Fade in down animation
 */
export const fadeInDown: Variants = {
  hidden: { opacity: 0, y: -20 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { duration: 0.6 }
  }
};

/**
 * Fade in left animation
 */
export const fadeInLeft: Variants = {
  hidden: { opacity: 0, x: -20 },
  visible: { 
    opacity: 1, 
    x: 0,
    transition: { duration: 0.6 }
  }
};

/**
 * Fade in right animation
 */
export const fadeInRight: Variants = {
  hidden: { opacity: 0, x: 20 },
  visible: { 
    opacity: 1, 
    x: 0,
    transition: { duration: 0.6 }
  }
};

/**
 * Zoom in animation
 */
export const zoomIn: Variants = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: { 
    opacity: 1, 
    scale: 1,
    transition: { duration: 0.6 }
  }
};

/**
 * Stagger children animation
 */
export const staggerContainer: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};

/**
 * Button hover animation
 */
export const buttonHover = {
  scale: 1.05,
  transition: { duration: 0.2 }
};

/**
 * Card hover animation
 */
export const cardHover = {
  y: -10,
  transition: { duration: 0.2 }
};

/**
 * Parallax scroll effect values
 * @param scrollY - Current scroll position
 * @param strength - Strength of the parallax effect (0-1)
 * @returns Y offset for the parallax element
 */
export const parallaxY = (scrollY: number, strength: number = 0.2): number => {
  return scrollY * strength;
};
